import { axios } from '@/lib/axios';
import { BookingDisplay } from '@/types';

export const getBookingDisplay = ({ bookableId }: { bookableId: number }): Promise<BookingDisplay[]> => {
  return axios.get(`/api/bookingDisplay/${bookableId}`);
};
